// extracted by mini-css-extract-plugin
export default {"bgBarTitle":"TitleForm-module--bgBarTitle--Lqbsg"};